/*
 * bundle-atc.js  (v2.1)
 * "Frequently bought together" bundle under the PDP Add-to-cart area.
 *
 *  - Tabs: click a tab to switch the visible product panel.
 *  - Color/variant: each card's <select> updates which variant adds + the price.
 *  - Selection: items are locked + always added; the button keeps its configured
 *    label (no count suffix).
 *  - "Add bundle to cart" adds the checked items (in their chosen color) to the cart,
 *    then refreshes + opens the cart drawer. The main product form is left alone.
 *    If a batch add fails (e.g. an item went out of stock), it retries item-by-item so
 *    the available items still get added.
 */
(function () {
  if (window.__pbundleInit) return;
  window.__pbundleInit = true;

  var S = {
    block: '[data-pbundle]',
    item: '[data-pbundle-item]',
    variantInput: '[data-pbundle-variant]',
    variantSelect: '[data-pbundle-variant-select]',
    price: '[data-pbundle-price]',
    tab: '[data-pbundle-tab]',
    panel: '[data-pbundle-panel]',
    add: '[data-pbundle-add]'
  };

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  // Only the active color group (visible panel) counts — single-color selection.
  function activePanel(block) { return block.querySelector(S.panel + '.is-active') || block; }

  function getSelectedItems(scope) {
    var items = [];
    (scope || document).querySelectorAll(S.variantInput).forEach(function (input) {
      if (!input.checked) return;
      var id = parseInt(input.getAttribute('data-pbundle-variant'), 10);
      if (id) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function updateCount(block) {
    var btn = block.querySelector(S.add);
    if (!btn) return;
    if (!btn.getAttribute('data-base-label')) btn.setAttribute('data-base-label', (btn.textContent || '').trim());
    var base = btn.getAttribute('data-base-label');
    var n = getSelectedItems(activePanel(block)).length;
    btn.textContent = base;
    btn.disabled = n === 0;
  }

  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  // Add items one at a time, ignoring individual failures (so one out-of-stock item
  // doesn't block the rest).
  function addOneByOne(items) {
    return items.reduce(function (p, it) {
      return p.then(function () { return postAdd([it]).catch(function () {}); });
    }, Promise.resolve());
  }

  function addBundle(btn) {
    var block = closest(btn, S.block);
    var items = getSelectedItems(activePanel(block));
    if (!items.length) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    postAdd(items)
      .then(function (r) { if (!r.ok) return addOneByOne(items); })
      .catch(function () { return addOneByOne(items); })
      .then(function () { return refreshAndOpenDrawer(); })
      .catch(function (err) { if (window.console) console.error('[bundle-atc] add failed', err); })
      .then(function () {
        btn.classList.remove('is-loading');
        updateCount(block);
      });
  }

  function switchTab(block, index) {
    block.querySelectorAll(S.tab).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-pbundle-tab') === String(index));
    });
    block.querySelectorAll(S.panel).forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-pbundle-panel') === String(index));
    });
    updateCount(block); // count reflects the now-active color group only
  }

  function refreshAndOpenDrawer() {
    // Preferred: use the theme's own pub/sub (exposed as window.emit) so the quick-cart
    // refreshes + opens NATIVELY. This is important because the theme rebuilds the whole
    // drawer container on an empty -> filled transition (and re-inits the free-shipping
    // bar, cross-sells, focus trap, body-scroll lock). Patching only inner selectors —
    // as the manual fallback below did originally — leaves the "Your cart is empty" state
    // on screen when the cart was empty before the bundle was added.
    if (typeof window.emit === 'function') {
      window.emit('quick-cart:updated'); // -> refreshQuickCart()
      window.emit('quick-cart:open');    // -> openQuickCart()
      return Promise.resolve();
    }

    // Fallback (only if window.emit is unavailable): refresh manually, mirroring the
    // theme's refreshQuickCart() — full container swap on an empty/filled state change,
    // otherwise patch the individual pieces.
    var qc = document.querySelector('[data-section-type="quick-cart"]');
    var routes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
    var base = routes.base || '/cart';
    if (!qc) { window.location.href = '/cart'; return Promise.resolve(); }
    var sectionId = qc.getAttribute('data-section-id');
    return fetch(base + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var srcInner = tmp.querySelector('.quick-cart__container');
        var dstInner = qc.querySelector('.quick-cart__container');
        var srcHasItems = !!tmp.querySelector('.quick-cart__items');
        var dstHasItems = !!qc.querySelector('.quick-cart__items');
        if (srcHasItems && dstHasItems) {
          ['.quick-cart__items', '.quick-cart__heading', '.quick-cart__footer-subtotal span', '.quick-cart__item-discounts'].forEach(function (sel) {
            var src = tmp.querySelector(sel);
            var dst = qc.querySelector(sel);
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
        } else if (srcInner && dstInner) {
          dstInner.innerHTML = srcInner.innerHTML; // empty <-> filled: swap whole container
        }
        var wrapper = qc.querySelector('.quick-cart__wrapper');
        if (wrapper) wrapper.classList.add('active');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var tabBtn = closest(e.target, S.tab);
    if (tabBtn) { switchTab(closest(tabBtn, S.block), tabBtn.getAttribute('data-pbundle-tab')); return; }

    var addBtn = closest(e.target, S.add);
    if (addBtn) { e.preventDefault(); addBundle(addBtn); return; }

    var item = closest(e.target, S.item);
    if (item && !closest(e.target, S.variantSelect) && !closest(e.target, 'a')) {
      var cb = item.querySelector(S.variantInput);
      if (cb && !cb.disabled) { // locked (disabled) items can't be toggled
        cb.checked = !cb.checked;
        item.classList.toggle('is-selected', cb.checked);
        var block = closest(item, S.block);
        if (block) updateCount(block);
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches(S.variantSelect)) return;
    var item = closest(e.target, S.item);
    if (!item) return;
    var opt = e.target.options[e.target.selectedIndex];
    var cb = item.querySelector(S.variantInput);
    if (cb) cb.setAttribute('data-pbundle-variant', e.target.value);
    var priceEl = item.querySelector(S.price);
    if (priceEl && opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
  });

  function init() { document.querySelectorAll(S.block).forEach(updateCount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
